import { Box, Spinner, Text } from '@chakra-ui/react'
import { useTranslation } from 'i11n/client'
import React from 'react'

export const LoadingDataWrapper = (props: {
  isLoading: boolean
  error?: unknown
  children: React.ReactNode
}) => {
  const t = useTranslation()

  if (props.isLoading) {
    return (
      <Box mt='5' w='full'>
        <Spinner />
      </Box>
    )
  }

  if (props.error) {
    return <Text>{t('Algo no salió como se esperaba')}</Text>
  }

  return <>{props.children}</>
}
